import React from 'react';
import styles from './index.module.less'
import cn from 'classnames';
import { IProduct } from 'base/interfaces/product';
import PointsTag from '@base/snippets/PointsTag';
import { useStore, observer } from 'base/store';

type IProps = {
    className?: string;
    product: IProduct;
}

const ListProductPoints: React.FC<IProps> = (props) => {
    const { userStore } = useStore();
    if (userStore.isDealer()) {
        return null;
    }

    const {
        className = '',
        product
    } = props

    return !product.points?.showTag ? null : (
        <div className={cn(
            className,
            'points',
            styles['points'],
            {[styles['has-points']]: product.points?.showTag}
        )}>
            <PointsTag hasBg={true} points={product.points}/>
        </div>
    );
};

export default observer(ListProductPoints)